export default  function ActivityLog(props) {

    const clientConfigApiDomain = process.env.REACT_APP_BACKEND_BASE_URL
    const saveImageApiUrl = `${clientConfigApiDomain}/userlog`
   fetch(saveImageApiUrl, { method: 'post' , body: JSON.stringify(props),
   headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => { })
    .catch(() => {
      console.log('ActivityLog catch error');       
    })
  }

